/** Clients & Staff Map Types */
export const GET_MAP_LOCATIONS = 'GET_MAP_LOCATIONS';
export const GET_MAP_LOCATIONS_SUCCESS = 'GET_MAP_LOCATIONS_SUCCESS';
/** End */
